export interface Review {
  id: string;
  userName: string;
  avatar: string;
  rating: number;
  content: string;
  date: string;
}

export interface AboutData {
  brandName: string;
  brandIntro: string;
  brandStory: string;
  mission: string;
  vision: string;
  stats: { label: string; value: string }[];
  team: { name: string; role: string; avatar: string }[];
  reviews: Review[];
  contact: {
    address: string;
    phone: string;
    email: string;
    wechat: string;
    workingHours: string;
  };
  faqs: { question: string; answer: string }[];
}

export const aboutData: AboutData = {
  brandName: '68影院',
  brandIntro: '68影院成立于2020年，是中国领先的在线电影内容平台，致力于为影迷提供最新、最全、最高清的电影资源。我们汇聚了海量国内外电影佳作，涵盖动作、喜剧、爱情、科幻、恐怖、剧情、动画等全品类影片，满足不同观众的观影需求。',
  brandStory: '68影院的创始团队由一群热爱电影的年轻人组成。在经历了无数次在网络上寻找高清电影资源却屡屡碰壁的体验后，他们决定创建一个真正为影迷服务的平台。从最初只有几十部电影的小网站，到如今拥有数万部电影的综合性平台，68影院始终坚持"让每个人都能看到好电影"的初心。我们相信，电影不仅是一种娱乐方式，更是一种文化和情感的载体。通过电影，我们可以体验不同的人生，感受不同的情感，理解不同的文化。',
  mission: '让每个人都能轻松找到并观看自己喜欢的电影，享受极致的观影体验。',
  vision: '成为中国最受信赖的在线电影平台，推动电影文化的普及和传播。',
  stats: [
    { label: '电影资源', value: '50,000+' },
    { label: '活跃用户', value: '800万+' },
    { label: '日均播放', value: '200万+' },
    { label: '用户好评', value: '98%' },
  ],
  team: [
    { name: '张明远', role: '创始人 & CEO', avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%2C%20business%20casual%20attire%2C%20friendly%20smile%2C%20clean%20white%20background%2C%20corporate%20headshot%20style&width=200&height=200&seq=team-01&orientation=squarish' },
    { name: '李思涵', role: '技术总监', avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%2C%20modern%20tech%20professional%2C%20confident%20expression%2C%20clean%20white%20background%2C%20corporate%20headshot%20style&width=200&height=200&seq=team-02&orientation=squarish' },
    { name: '王子轩', role: '内容总监', avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%2C%20creative%20professional%2C%20warm%20smile%2C%20clean%20white%20background%2C%20corporate%20headshot%20style&width=200&height=200&seq=team-03&orientation=squarish' },
    { name: '陈雨桐', role: '运营总监', avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%2C%20business%20professional%2C%20friendly%20expression%2C%20clean%20white%20background%2C%20corporate%20headshot%20style&width=200&height=200&seq=team-04&orientation=squarish' },
  ],
  reviews: [
    {
      id: 'review-1',
      userName: '电影发烧友小王',
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20portrait%2C%20friendly%20face%2C%20casual%20style%2C%20clean%20white%20background%2C%20avatar%20style&width=100&height=100&seq=avatar-01&orientation=squarish',
      rating: 5,
      content: '68影院真的太好用了！电影资源超级全，画质也很清晰，最重要的是不用等缓冲，体验感拉满。已经推荐给身边所有朋友了！',
      date: '2026-07-30',
    },
    {
      id: 'review-2',
      userName: '资深影评人老李',
      avatar: 'https://readdy.ai/api/search-image?query=Middle-aged%20Chinese%20man%20portrait%2C%20intellectual%20look%2C%20glasses%2C%20clean%20white%20background%2C%20avatar%20style&width=100&height=100&seq=avatar-02&orientation=squarish',
      rating: 5,
      content: '作为一个看了二十年电影的老影迷，68影院的片库之丰富让我惊喜。从经典老片到最新上映的大片都有，分类也很细致，找片非常方便。',
      date: '2026-07-25',
    },
    {
      id: 'review-3',
      userName: '追剧小能手',
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20trendy%20style%2C%20bright%20smile%2C%20clean%20white%20background%2C%20avatar%20style&width=100&height=100&seq=avatar-03&orientation=squarish',
      rating: 4,
      content: '每天下班回家第一件事就是打开68影院看电影，已经成了习惯。页面设计很简洁好看，用起来很顺手。希望以后能出更多独家内容！',
      date: '2026-07-20',
    },
    {
      id: 'review-4',
      userName: '周末影院',
      avatar: 'https://readdy.ai/api/search-image?query=Chinese%20couple%20portrait%2C%20casual%20and%20happy%2C%20clean%20white%20background%2C%20avatar%20style&width=100&height=100&seq=avatar-04&orientation=squarish',
      rating: 5,
      content: '每个周末都会和女朋友一起在68影院看电影，片源更新速度很快，新上映的大片很快就能看到。排行榜功能也很实用，帮我们发现了很多好片。',
      date: '2026-07-18',
    },
  ],
  contact: {
    address: '北京市朝阳区望京SOHO T1栋 1608室',
    phone: '400-888-6868',
    email: 'contact@68cinema.com',
    wechat: 'Cinema68Official',
    workingHours: '周一至周日 9:00 - 22:00',
  },
  faqs: [
    {
      question: '68影院的电影资源是免费的吗？',
      answer: '68影院提供大量免费高清电影资源供用户在线观看。部分最新上映的热门影片可能需要会员权限。我们致力于为用户提供最优质、最丰富的观影体验。',
    },
    {
      question: '如何搜索我想看的电影？',
      answer: '您可以通过首页顶部的搜索框输入电影名称进行搜索，也可以通过分类页面按电影类型浏览。我们还提供了热门排行榜和最新电影列表，帮助您发现更多精彩内容。',
    },
    {
      question: '支持哪些设备观看？',
      answer: '68影院支持在电脑、平板和手机等多种设备上观看。只需使用浏览器访问我们的网站即可，无需下载任何软件。我们的网站采用响应式设计，能够自动适配不同屏幕尺寸。',
    },
    {
      question: '影片的画质如何？',
      answer: '68影院提供720P、1080P及4K等多种清晰度选择，您可以根据自己的网络状况和设备性能选择合适的画质。我们始终坚持为用户提供最佳的观影体验。',
    },
    {
      question: '如何联系客服？',
      answer: '您可以通过以下方式联系我们的客服团队：发送邮件至 contact@68cinema.com，或在工作时间（周一至周日 9:00-22:00）拨打客服热线 400-888-6868。我们的客服团队将竭诚为您服务。',
    },
  ],
};